import { render, staticRenderFns } from "./testDetail.vue?vue&type=template&id=7c42eff8&scoped=true&"
import script from "./testDetail.vue?vue&type=script&lang=js&"
export * from "./testDetail.vue?vue&type=script&lang=js&"
import style0 from "./testDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./testDetail.vue?vue&type=style&index=1&id=7c42eff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c42eff8",
  null
  
)

export default component.exports